import { CheckOutlined } from '@ant-design/icons';
import { Button, Card, Radio } from 'antd';
import { map } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { selectStore, selectUser } from '../../redux/auth/authSlice';
import { userStoreType } from '../../redux/auth/authTypes';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

interface StoreSelectorProps {
  onSubmit?: () => void;
}

const StoreSelector = ({ onSubmit }: StoreSelectorProps) => {
  const user = useAppSelector(selectUser);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [active, setActive] = useState<userStoreType | undefined>(user?.userStores?.[0]);

  const handleSubmit = () => {
    if (active) dispatch(selectStore({ store: active }));
    onSubmit?.();
  };

  return (
    <div className="px-4 gap-4 mt-2">
      <h3 className="capitalize text-sm font-medium leading-6 text-gray-900">
        {t('store_select_title')}
      </h3>
      <Card className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
        <Radio.Group
          value={active?._id}
          onChange={(e) => setActive(user?.userStores?.find((s) => s._id === e.target.value))}
          className="space-y-2"
        >
          {map(user?.userStores, (store) => (
            <Radio
              key={store._id}
              value={store._id}
              className="flex items-center justify-between w-full"
            >
              <span>{store.name}</span>
              {active?._id === store._id && <CheckOutlined className="text-blue-600" />}
            </Radio>
          ))}
        </Radio.Group>
      </Card>
      <Button type="primary" onClick={handleSubmit} className="w-full mt-4" disabled={!active}>
        {t('common:submit')}
      </Button>
    </div>
  );
};

export default StoreSelector;
